<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aQBGMz/tc-custom/9780316407342.jpg?1737197407770" alt="This image is the cover for the book Jinn and Juice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jinn and Juice
      </h1>
      <p class="bookDescription body article font2">
        <b>In this rowdy and raunchy urban fantasy, Lyla escaped an arranged marriage by accepting a deal from a jinni -- to live a thousand years as a jinni herself. Now, with her millennia nearly up, she's hiding out in a seedy Pittsburgh swarming with vampires, jinni and magical beings.</b><b><br/><br/>Meet Lyla, a thousand-year-old Jinn, a belly dancer, and the hottest new urban fantasy heroine in town.<br/><br/>With her thousand-year-long servitude ending, Lyla faces a few serious obstacles to freedom. A Magi intent on binding her again, a jinni bent on vengeance, and not to mention the nightmare from her past that threatens to make her curse permanent -- and claim her very soul. <br/><br/>"<i>Jinn and Juice</i> is a raucous, raunchy tale well told. One thing's certain: you'll never look at Pittsburgh the same way after you've taken Nicole Peeler's mythic joyride up, down, and sideways in pursuit of an abducted teenage girl and freedom from a thousand-year curse. Legend and history, betrayal and love intertwine as the story moves from lascivious sex clubs to the unraveling of a mystery to a magical jinni throw-down which will leave you panting for more. <i>Jinn and Juice</i> is Urban Fantasy at its smartest, naughtiest, funniest best." -- Juliet Blackwell<br/></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicole Peeler
      </h2>
      
      <p class="authorDescription body article"><B>Nicole Peeler</B> writes urban fantasy and is an associate professor at Seton Hill University, where she co-directs their MFA in Writing Popular Fiction. She is the author of the award-winning Jane True series and <I>Jinn and Juice</I>, the first book in a series about a cursed jinni living in Pittsburgh. Nicole also lives in Pittsburgh, although she's neither cursed nor a jinni.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit / Yen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb4977b0